import {createEntityService} from 'utils/createEntityService';
import {MedicalDocument} from 'types/medicalDocument';

export const MedicalDocumentService = createEntityService<MedicalDocument>({
  baseUrl: 'api/v1/medical_documents',
  entityName: 'medicalDocument',
});
